import { createFileRoute, redirect } from "@tanstack/react-router";
import { ActionPage } from "@/features/publiclinks/ActionPage";
import { serverAuth } from "@/data/auth";

/** Public action link for one waiting item. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/action/$token")({
  beforeLoad: () => {
    if (serverAuth) throw redirect({ to: "/portal" });
  },
  component: ActionRoute,
});

function ActionRoute() {
  const { token } = Route.useParams();
  return <ActionPage token={token} />;
}
